<template>
  <v-app>
    <HeaderTemplate />
    <MenuTemplate />
    <v-main class="cor-fundo">
      <v-container style="height: 100% !important" class="mb-3" fluid>
        <snack-erro />

        <v-layout align-center fill-height justify-center v-if="loading || syncPedidos || loadingApp">
          <v-progress-circular size="55" width="2" indeterminate></v-progress-circular>
        </v-layout>
        <router-view v-show="!loading && !syncPedidos && !loadingApp" />
      </v-container>
    </v-main>
    <FooterTemplate />
  </v-app>
</template>

<script>
import HeaderTemplate from "./template/Header.vue";
import MenuTemplate from "./template/Menu.vue";
import FooterTemplate from "./template/Footer.vue";
import { iniciarBancoDados } from "./db/db";
import SnackErro from "./components/tela/SnackErro.vue";
import { mapState } from "vuex";

export default {
  components: {
    HeaderTemplate,
    MenuTemplate,
    FooterTemplate,
    SnackErro,
  },
  name: "App",
  computed: {
    ...mapState("pedidos", ["syncPedidos"]),
    ...mapState("sistema", ["loadingApp"]),
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async created() {
    this.loading = true;
    await iniciarBancoDados();
    this.loading = false;
  },
};
</script>

<style>
* {
  text-transform: none;
  font-family: "Poppins" !important;
  word-break: normal !important;
}

.cor-fundo {
  /*background-color: #dfdcdc !important;*/
  background-color: #e6e6e6 !important;
}

.toasted {
  font-size: 1.1rem !important;
}
</style>
